module.exports = __webpack_public_path__ + "static/media/12UNCTAD17.5c68691c.jpg";